module.exports = __webpack_public_path__ + "img/base.e2153a77.png";